export default __webpack_public_path__ + "static/media/465.7a46da40.jpg";